exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".message-counter[data-v-a35af8ae]{text-align:center;color:var(--wf-tertiary);font-weight:600;position:absolute;cursor:pointer;top:0;left:0;right:0;bottom:0;display:inline-flex;align-items:center;justify-content:center}.message-counter[data-v-a35af8ae]:hover{background:var(--secondary-tertiary-mix95)}.message-counter img[data-v-a35af8ae]{max-width:50px}.message-count[data-v-a35af8ae]{position:absolute;transform:translate(-50%,-25%);color:var(--wf-secondary);font-size:1rem}", ""]);

// exports
